<template>
  <div :class="$style.loadingPage">
    <LoadingBox style="z-index: 2;" />
    <!-- <div :class="$style.footerLogo">
      <img src="@/assets/footer_logo.svg" />
    </div> -->
  </div>
</template>

<script>
import LoadingBox from '@/components/LoadingBox'

export default {
  name: 'LoadingPage',
  components: { LoadingBox }
}
</script>

<style lang="scss" module>
.footerLogo {
  position: absolute;
  bottom: 60px;
  text-align: center;
  width: 100%;

  img {
    width: 155px;
    height: 43px;
  }
}
</style>
